import styled from 'styled-components';
import theme from '../../../styles/theme';

import LabelContainer from '../../molecules/LabelContainer';

export const Container = styled.div`
  //display: flex;
  margin-top: 10px !important;
  justify-content: space-between;

  svg {
    height: 20px;
    width: 20px;
  }
`;

export const ContentText = styled.div`
  font: normal normal normal 15px 'work_sans';
  color: ${theme.movGrey};
  align-self: center;
  margin-bottom: 30px;
  margin-top: 28px;
  text-align: center;
`;

export const Content = styled.div`
  padding: 10px;
  align-self: center;
`;

export const InlineContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  margin-left: -5px;

  > label {
    margin-bottom: 0px;
  }
`;

export const FootlineContainer = styled.div`
  display: flex;
  padding-left: 5%;
  margin-top: 10px !important;
`;

export const DateContainer = styled.div`
  display: flex;
  height: 47;
`;

export const ComboDatePicker = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 3px;

  p {
    margin: 15px;
  }
`;

export const ContButton = styled.div`
  padding-top: 3%;
  padding-left: 5px;
  display: 'none';
`;

export const LabelDate = styled.label`
  text-align: left;
  font: 300 15px Calibri;
  letter-spacing: 0.52px;
  opacity: 1;
  margin: 5px;

  & > div {
    height: 47px;
  }
`;
